import { render, staticRenderFns } from "./StagesAdminPage.vue?vue&type=template&id=ae6068de&scoped=true"
import script from "./StagesAdminPage.vue?vue&type=script&lang=js"
export * from "./StagesAdminPage.vue?vue&type=script&lang=js"
import style0 from "./StagesAdminPage.vue?vue&type=style&index=0&id=ae6068de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6068de",
  null
  
)

export default component.exports